// extracted by mini-css-extract-plugin
export default {"LaunchButton":"_LaunchButton--fT91P","icon":"_icon--kvtKf","CreateNewDocument":"_CreateNewDocument--swWQU","AddIcon":"_AddIcon--tLwx_"};